<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 14:25:38
 * @LastEditTime: 2025-12-25 09:27:35
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div
    :class="[
      'c-menu_item',
      !$attrs.isFixedMenu && ($attrs.isShowTooltip !== undefined ? $attrs.isShowTooltip : true)
        ? 'is-narrow_menu_item'
        : ''
    ]"
  >
    <el-tooltip
      v-if="!$attrs.isFixedMenu && ($attrs.isShowTooltip !== undefined ? $attrs.isShowTooltip : true) && $slots.title"
      effect="dark"
      placement="top"
      :disabled="$attrs.isDisabled != undefined ? $attrs.isDisabled : false"
    >
      <div slot="content">
        <slot name="title" v-if="isUseCustomStr"></slot>
        <span v-else>{{ customStr }}</span>
      </div>
      <div class="tooltip_item_wrap">
        <slot></slot>
        <slot name="title"></slot>
      </div>
    </el-tooltip>
    <template v-else>
      <div class="defaultDisplayFlex" style="overflow: hidden">
        <slot></slot>
        <slot name="title"></slot>
      </div>
      <div class="defaultDisplayFlex">
        <slot name="num"></slot>
        <slot name="operate"></slot>
        <slot name="arrow"></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    isUseCustomStr: {
      type: Boolean,
      default: true
    },
    customStr: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.c-menu_item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  justify-content: space-between;
  padding-right: 0;
  .icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 6px;
    color: #4e5969;
  }
  .label {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #1d2129;
  }
  .arrow_icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #86909c;
    transform: rotate(-90deg);
    transition: transform 0.3s;
    &.is-rotate {
      transform: rotate(0deg);
    }
  }
  .num {
    height: 16px;
    line-height: 16px;
    white-space: nowrap;
    display: inline-block;
    padding: 0 6px;
    text-align: center;
    background: #ff3c38;
    border-radius: 50%;
    margin-right: 4px;
    font-family: Arial, Arial;
    font-weight: normal;
    font-size: 9px;
    color: #ffffff;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
  &:hover {
    background: rgba(210, 231, 254, 1);
    border-radius: 8px;
    cursor: pointer;
    box-shadow: none !important;
    .icon {
      color: #165dff;
    }
    .label {
      color: #165dff;
      //font-weight: 500;
    }
    .arrow_icon {
      // color: #165DFF;
    }
  }
  &.is-active {
    box-shadow: 0px -1px 0px 0px #e0e3ed;
    background: rgba(210, 231, 254, 1);
    border-radius: 8px;
    .icon {
      color: #165dff;
    }
    .label {
      color: #165dff !important;
      font-weight: 500;
    }

    &:hover {
      background: rgba(210, 231, 254, 1) !important;
      box-shadow: 0px -1px 0px 0px #e0e3ed !important;
    }
  }

  .is-narrow_menu_item {
    padding: 0;
    z-index: 3;
    position: relative;
    justify-content: center;
    .tooltip_item_wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;
      ::v-deep .icon_wrap {
        padding: 9px 10px;
        .icon {
          width: 20px;
          height: 20px;
          color: rgba(255, 255, 255, 0.7);
        }
      }
      ::v-deep .label {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        font-size: 12px;
        color: #1d2129;
        line-height: 17px;
        margin-top: 2px;
        max-width: 100%;
      }
    }
    &:hover {
      background: transparent;
      border-radius: 0;
      ::v-deep .icon_wrap {
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.2);
        .icon {
          color: #fff;
        }
      }
    }
    &.is-active {
      box-shadow: none;
      ::v-deep .tooltip_item_wrap {
        .icon_wrap {
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }
  }
  .defaultDisplayFlex {
    display: flex;
    align-items: center;
  }
}
</style>
